import script from "./BuscadorParaTi.vue?vue&type=script&setup=true&lang=js"
export * from "./BuscadorParaTi.vue?vue&type=script&setup=true&lang=js"

import "./BuscadorParaTi.vue?vue&type=style&index=0&id=4d7f6a37&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7f6a37"]])

export default __exports__